class HelpController {
  constructor($stateParams, $state) {
    'ngInject';
    Object.assign(this, { $stateParams, $state })
  }

  $onInit () {
    if (this.$stateParams.sectionId) {
      document.getElementById(this.$stateParams.sectionId).scrollIntoView({
        behavior: "smooth"
      });
    }
    if (this.$stateParams.prevRoute) {
      this.prevRoute = this.$stateParams.prevRoute
    }
  }

  goToPrevRoute () {
    if (this.prevRoute) {
      this.$state.go(this.prevRoute)
    }
  }
}

export default HelpController;



// WEBPACK FOOTER //
// ./client/app/modules/help/help.controller.js